// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E90N","tabsBox":"styles_tabsBox__3NZ-A","createButton":"styles_createButton__1MQmJ"};